(function () {
  // Ask Trustshop to render every review; we present them one-at-a-time in a carousel.
  const LOAD_ALL = 100;
  const DOT_LIMIT = 6;
  const ITEM_SELECTOR = [
    '.trustshop-review-item-type--list',
    '.trustshop-review-item-type--grid',
    '.trustshop-review-item',
  ].join(', ');

  const WRITE_BTN_SELECTOR = [
    '#trustshop-no-review--button',
    '#trustshop-write--review',
    'button.trustshop-no-review--button',
  ].join(', ');

  const ready = (fn) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  };

  const forcePerPage = () => {
    window.__ts__ = window.__ts__ || {};
    window.__ts__.settings = window.__ts__.settings || {};
    window.__ts__.settings['trustshop-widget_box_review_per_page'] = JSON.stringify({
      review_per_page_desktop: String(LOAD_ALL),
      review_per_page_mobile: String(LOAD_ALL),
    });
  };

  const uniqueItems = (root) => {
    const nodes = Array.from(root.querySelectorAll(ITEM_SELECTOR));
    return nodes.filter((node) => !nodes.some((other) => other !== node && other.contains(node)));
  };

  const writeReviewButton = () => document.querySelector(WRITE_BTN_SELECTOR);

  const revealWriteButton = () => {
    const writeBtn = writeReviewButton();
    if (!writeBtn) return null;

    // Trustshop empty chrome / our duplicate-CTA hide uses display:none; briefly reveal so its handler can run
    const restored = [];
    let node = writeBtn;
    while (node && node !== document.body) {
      if (getComputedStyle(node).display === 'none') {
        restored.push([node, node.style.getPropertyValue('display'), node.style.getPropertyPriority('display')]);
        node.style.setProperty('display', 'block', 'important');
      }
      node = node.parentElement;
    }

    return { writeBtn, restored };
  };

  const restoreHidden = (restored) => {
    (restored || []).forEach(([el, value, priority]) => {
      if (value) el.style.setProperty('display', value, priority || '');
      else el.style.removeProperty('display');
    });
  };

  const unlockModalCard = (el) => {
    if (!el) return;
    el.style.setProperty('height', 'auto', 'important');
    el.style.setProperty('max-height', 'none', 'important');
    el.style.setProperty('min-height', '0', 'important');
    el.style.setProperty('overflow', 'visible', 'important');
    el.style.setProperty('width', 'min(480px, 100%)', 'important');
    el.style.setProperty('max-width', '100%', 'important');
    el.style.setProperty('flex', '0 0 auto', 'important');
    el.style.setProperty('box-sizing', 'border-box', 'important');
    el.style.setProperty('position', 'relative', 'important');
    el.style.setProperty('top', 'auto', 'important');
    el.style.setProperty('left', 'auto', 'important');
    el.style.setProperty('right', 'auto', 'important');
    el.style.setProperty('bottom', 'auto', 'important');
    el.style.setProperty('margin', '0 auto', 'important');
  };

  let modalGuard = null;
  let modalGuardTimer = null;
  let modalApplying = false;
  let openRetryTimer = null;

  const isWriteModalOpen = (form) =>
    !!(form && /show-form-write/i.test(form.className || ''));

  const stopModalGuard = () => {
    if (modalGuardTimer) {
      window.clearTimeout(modalGuardTimer);
      modalGuardTimer = null;
    }
    if (modalGuard) {
      modalGuard.disconnect();
      modalGuard = null;
    }
    modalApplying = false;
  };

  const closeWriteModal = () => {
    if (openRetryTimer) {
      window.clearInterval(openRetryTimer);
      openRetryTimer = null;
    }
    stopModalGuard();
    const form = document.querySelector('#trustshop-form-review--container');
    if (form) {
      form.classList.remove('show-form-write--review');
      form.style.setProperty('display', 'none', 'important');
      form.style.setProperty('visibility', 'hidden', 'important');
      form.style.setProperty('pointer-events', 'none', 'important');
    }
    document.body.classList.remove('trustshop-modal--open');
    document.documentElement.classList.remove('trustshop-modal--open');
  };

  const applyModalLayout = (form) => {
    if (!form || !isWriteModalOpen(form)) return;
    modalApplying = true;
    form.style.setProperty('position', 'fixed', 'important');
    form.style.setProperty('inset', '0', 'important');
    form.style.setProperty('top', '0', 'important');
    form.style.setProperty('right', '0', 'important');
    form.style.setProperty('bottom', '0', 'important');
    form.style.setProperty('left', '0', 'important');
    form.style.setProperty('width', '100%', 'important');
    form.style.setProperty('min-width', '100%', 'important');
    form.style.setProperty('height', '100%', 'important');
    form.style.setProperty('min-height', '100%', 'important');
    form.style.setProperty('max-width', 'none', 'important');
    form.style.setProperty('max-height', 'none', 'important');
    form.style.setProperty('display', 'flex', 'important');
    form.style.setProperty('align-items', 'flex-start', 'important');
    form.style.setProperty('justify-content', 'center', 'important');
    form.style.setProperty('visibility', 'visible', 'important');
    form.style.setProperty('pointer-events', 'auto', 'important');
    form.style.setProperty('margin', '0', 'important');
    form.style.setProperty('padding', '2.4rem 1.5rem', 'important');
    form.style.setProperty('overflow-x', 'hidden', 'important');
    form.style.setProperty('overflow-y', 'auto', 'important');
    form.style.setProperty('box-sizing', 'border-box', 'important');
    form.style.setProperty('z-index', '2147483000', 'important');

    const wrap =
      form.querySelector('#trustshop-review--wrap') ||
      form.querySelector('.show-form-write--review-wrap');
    const field = form.querySelector('.trustshop-form-review--field');
    const inner = form.querySelector('.trustshop-form--review, .trustshop-show--form');
    unlockModalCard(wrap);
    unlockModalCard(field);
    unlockModalCard(inner);

    form.querySelectorAll('input, textarea, select, button, .trustshop-form-button, [class*="upload"]').forEach((el) => {
      el.style.setProperty('max-width', '100%', 'important');
      el.style.setProperty('box-sizing', 'border-box', 'important');
    });
    window.setTimeout(() => {
      modalApplying = false;
    }, 0);
  };

  const centerWriteModal = () => {
    const form = document.querySelector('#trustshop-form-review--container');
    if (!form || !isWriteModalOpen(form)) {
      stopModalGuard();
      return false;
    }

    applyModalLayout(form);

    if (!modalGuard) {
      modalGuard = new MutationObserver(() => {
        if (modalApplying) return;
        if (!document.body.contains(form) || !isWriteModalOpen(form)) {
          closeWriteModal();
          return;
        }
        if (modalGuardTimer) window.clearTimeout(modalGuardTimer);
        modalGuardTimer = window.setTimeout(() => applyModalLayout(form), 40);
      });
      modalGuard.observe(form, {
        attributes: true,
        attributeFilter: ['style', 'class'],
        childList: true,
        subtree: true,
      });
    }

    return true;
  };

  const openWriteReview = () => {
    const revealed = revealWriteButton();
    if (!revealed) return false;

    // Nested click() during a bubbling click is ignored by browsers — defer it
    window.setTimeout(() => {
      revealed.writeBtn.click();
      // Form portals to body; safe to re-hide empty chrome after Trustshop opens
      window.setTimeout(() => {
        restoreHidden(revealed.restored);
        centerWriteModal();
        let tries = 0;
        if (openRetryTimer) window.clearInterval(openRetryTimer);
        openRetryTimer = window.setInterval(() => {
          tries += 1;
          if (centerWriteModal() || tries >= 20) {
            window.clearInterval(openRetryTimer);
            openRetryTimer = null;
          }
        }, 80);
      }, 50);
    }, 0);

    return true;
  };

  // Event delegation survives theme-dev hot reloads
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('.product-reviews-empty__write');
    if (!trigger) return;
    event.preventDefault();
    event.stopPropagation();
    if (openWriteReview()) return;

    let attempts = 0;
    const timer = window.setInterval(() => {
      attempts += 1;
      if (openWriteReview() || attempts >= 12) window.clearInterval(timer);
    }, 250);
  });

  document.addEventListener('click', (event) => {
    const form = document.querySelector('#trustshop-form-review--container');
    if (!form || !isWriteModalOpen(form)) return;

    const closeBtn = event.target.closest(
      '.trustshop-close-modal--btn, [aria-label="Close"], [aria-label="close"]'
    );
    const clickedBackdrop = event.target === form;

    if (!closeBtn && !clickedBackdrop) return;

    event.preventDefault();
    event.stopPropagation();
    closeWriteModal();
  }, true);

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const form = document.querySelector('#trustshop-form-review--container');
    if (!form || !isWriteModalOpen(form)) return;
    closeWriteModal();
  });

  const LIST_SELECTOR =
    '.trustshop-review--list, .trustshop-review-list--grid, .trustshop-review-list--list';

  const ensureCarouselNav = (panel) => {
    let nav = panel.querySelector(':scope > .product-reviews-carousel');
    if (nav) return nav;

    const legacy = panel.querySelector(':scope > .product-reviews-pagination');
    nav = document.createElement('nav');
    nav.className = 'product-reviews-carousel';
    nav.setAttribute('aria-label', 'Reviews carousel');
    nav.hidden = true;
    if (legacy) legacy.replaceWith(nav);
    else panel.appendChild(nav);
    return nav;
  };

  const placeWriteButton = (panel) => {
    const writeBtn = panel.querySelector(':scope > .product-reviews-empty__write');
    if (!writeBtn) return;
    const carousel = panel.querySelector(':scope > .product-reviews-carousel');
    const block =
      panel.querySelector(':scope > .shopify-block, :scope > .shopify-app-block, :scope > .trustshop-widget-box, :scope > #trustshop-review') ||
      panel.querySelector('.shopify-block, .trustshop-widget-box, #trustshop-review');
    if (!block) return;
    // Keep Write CTA after Trustshop content so reviews aren't pushed below the fold
    if (writeBtn.compareDocumentPosition(block) & Node.DOCUMENT_POSITION_FOLLOWING) {
      if (carousel) panel.insertBefore(writeBtn, carousel);
      else block.after(writeBtn);
    }
  };

  const initPanel = (panel) => {
    if (!panel || panel.dataset.reviewsReady === 'true') return;
    panel.dataset.reviewsReady = 'true';
    panel.classList.add('product-reviews-panel--carousel');

    const emptyState = panel.querySelector('.product-reviews-empty');
    const nav = ensureCarouselNav(panel);
    let index = 0;
    let syncing = false;

    const getTrack = () => panel.querySelector(LIST_SELECTOR);

    const prepareSlides = () => {
      const items = uniqueItems(panel);
      items.forEach((item) => {
        if (item.hidden) item.hidden = false;
        if (item.style.display === 'none') item.style.display = '';
        item.classList.add('product-reviews-slide');
      });
      return items;
    };

    const renderNav = (count, active) => {
      if (count <= 1) {
        if (!nav.hidden || nav.innerHTML) {
          nav.hidden = true;
          nav.innerHTML = '';
        }
        return;
      }

      nav.hidden = false;
      const useDots = count <= DOT_LIMIT;
      const middle = useDots
        ? `<div class="product-reviews-carousel__dots">${Array.from({ length: count }, (_, i) => {
            const on = i === active;
            return `<button type="button" class="product-reviews-carousel__dot${
              on ? ' is-active' : ''
            }" data-index="${i}" aria-label="Review ${i + 1}"${on ? ' aria-current="true"' : ''}></button>`;
          }).join('')}</div>`
        : `<p class="product-reviews-carousel__status" aria-live="polite">${active + 1} / ${count}</p>`;

      const html = [
        `<button type="button" class="product-reviews-carousel__btn" data-dir="-1" aria-label="Previous review"${
          active === 0 ? ' disabled' : ''
        }>&#8249;</button>`,
        middle,
        `<button type="button" class="product-reviews-carousel__btn" data-dir="1" aria-label="Next review"${
          active >= count - 1 ? ' disabled' : ''
        }>&#8250;</button>`,
      ].join('');

      if (nav.dataset.active !== String(active) || nav.dataset.count !== String(count)) {
        nav.innerHTML = html;
        nav.dataset.active = String(active);
        nav.dataset.count = String(count);
      } else {
        const status = nav.querySelector('.product-reviews-carousel__status');
        if (status) status.textContent = `${active + 1} / ${count}`;
        nav.querySelectorAll('.product-reviews-carousel__dot').forEach((dot, i) => {
          dot.classList.toggle('is-active', i === active);
          if (i === active) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        const prev = nav.querySelector('[data-dir="-1"]');
        const next = nav.querySelector('[data-dir="1"]');
        if (prev) prev.disabled = active === 0;
        if (next) next.disabled = active >= count - 1;
      }
    };

    const scrollToIndex = (nextIndex, behavior = 'smooth') => {
      const slides = prepareSlides();
      if (!slides.length) return;
      index = Math.max(0, Math.min(nextIndex, slides.length - 1));
      const track = getTrack();
      const slide = slides[index];
      if (track && slide) {
        const left = slide.offsetLeft - track.offsetLeft;
        track.scrollTo({ left, behavior });
      }
      renderNav(slides.length, index);
    };

    const syncIndexFromScroll = () => {
      const track = getTrack();
      const slides = prepareSlides();
      if (!track || !slides.length) return;
      const left = track.scrollLeft;
      let nearest = 0;
      let best = Infinity;
      slides.forEach((slide, i) => {
        const dist = Math.abs(slide.offsetLeft - track.offsetLeft - left);
        if (dist < best) {
          best = dist;
          nearest = i;
        }
      });
      if (nearest !== index) {
        index = nearest;
        renderNav(slides.length, index);
      }
    };

    const sync = () => {
      if (syncing) return;
      syncing = true;
      try {
        forcePerPage();
        placeWriteButton(panel);

        panel
          .querySelectorAll(
            '.shopify-block.ecko-reviews-empty, .trustshop-review-wrap.ecko-reviews-empty, .trustshop-widget-box.ecko-reviews-empty, .trustshop.ecko-reviews-empty'
          )
          .forEach((el) => {
            if (el.matches('.trustshop-no--review, .trustshop-no-review, .ts-no-review')) return;
            el.classList.remove('ecko-reviews-empty');
          });

        const allItems = uniqueItems(panel);
        panel.classList.toggle('is-empty', allItems.length === 0);

        if (!allItems.length) {
          if (emptyState) {
            emptyState.hidden = false;
            emptyState.removeAttribute('aria-hidden');
          }
          nav.hidden = true;
          nav.innerHTML = '';
          nav.dataset.active = '';
          nav.dataset.count = '';
          return;
        }

        if (emptyState) {
          emptyState.hidden = true;
          emptyState.setAttribute('aria-hidden', 'true');
        }

        const slides = prepareSlides();
        if (index >= slides.length) index = Math.max(0, slides.length - 1);

        const track = getTrack();
        if (track) track.classList.add('product-reviews-track');

        renderNav(slides.length, index);
        // Re-align after Trustshop reflows
        window.requestAnimationFrame(() => scrollToIndex(index, 'auto'));
      } finally {
        window.setTimeout(() => {
          syncing = false;
        }, 0);
      }
    };

    nav.addEventListener('click', (event) => {
      const dirBtn = event.target.closest('[data-dir]');
      if (dirBtn && !dirBtn.disabled) {
        scrollToIndex(index + Number(dirBtn.dataset.dir));
        return;
      }
      const dot = event.target.closest('[data-index]');
      if (!dot) return;
      scrollToIndex(Number(dot.dataset.index) || 0);
    });

    const bindTrackScroll = () => {
      const track = getTrack();
      if (!track || track.dataset.carouselScroll === 'true') return;
      track.dataset.carouselScroll = 'true';
      let ticking = false;
      track.addEventListener(
        'scroll',
        () => {
          if (ticking) return;
          ticking = true;
          window.requestAnimationFrame(() => {
            syncIndexFromScroll();
            ticking = false;
          });
        },
        { passive: true }
      );
    };

    const observer = new MutationObserver(() => {
      if (syncing) return;
      bindTrackScroll();
      sync();
    });
    observer.observe(panel, { childList: true, subtree: true });

    const details = panel.closest('details');
    details?.addEventListener('toggle', () => {
      if (!details.open) return;
      forcePerPage();
      if (typeof window.trustshop_widget_box === 'function') {
        window.trustshop_widget_box();
      }
      bindTrackScroll();
      sync();
    });

    bindTrackScroll();
    sync();
    [300, 800, 1600, 3200].forEach((delay) => window.setTimeout(sync, delay));
  };

  const wrapOrphanReviews = () => {
    const orphan = document.querySelector(
      '.product__info-container > [id*="widget_box"], .product__info-container > [id*="widget-box"]'
    );

    if (!orphan || orphan.closest('.product__accordion--reviews')) return;

    const sample = document.querySelector('.product__accordion summary');
    const accordion = document.createElement('div');
    accordion.className =
      'product__accordion accordion product__accordion--toggle product__accordion--reviews quick-add-hidden';
    accordion.innerHTML = `
      <details>
        <summary></summary>
        <div class="accordion__content product-reviews-panel">
          <div class="product-reviews-empty" hidden>
            <p class="product-reviews-empty__copy">No reviews yet. Be the first to share your feedback.</p>
          </div>
          <button type="button" class="product-reviews-empty__write">Write a review</button>
          <nav class="product-reviews-carousel" hidden aria-label="Reviews carousel"></nav>
        </div>
      </details>
    `;
    const summary = accordion.querySelector('summary');
    if (sample) {
      summary.innerHTML = sample.innerHTML;
      const title = summary.querySelector('.accordion__title');
      if (title) title.textContent = 'Customer Reviews';
    } else {
      summary.innerHTML =
        '<div class="summary__title"><h2 class="h4 accordion__title">Customer Reviews</h2></div>';
    }

    orphan.parentNode.insertBefore(accordion, orphan);
    const panel = accordion.querySelector('.product-reviews-panel');
    const writeBtn = panel.querySelector('.product-reviews-empty__write');
    panel.insertBefore(orphan, writeBtn);
  };

  ready(() => {
    forcePerPage();
    const run = () => {
      wrapOrphanReviews();
      document.querySelectorAll('.product-reviews-panel').forEach(initPanel);
    };
    run();
    [200, 800, 2000].forEach((delay) => window.setTimeout(run, delay));
  });
})();
